import { Event } from '../../types'
import EventNotes from './notes'

const events: Array<Event> = [
	{
		name: 'Egg Festival',
		date: {
			season: 1,
			day: 13
		},
		location: 'Town Square',
		time: {
			start: '9:00 AM',
			end: '2:00 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Egg Festival']
	},
	{
		name: 'Desert Festival',
		date: {
			season: 1,
			day: 15
		},
		location: 'Desert',
		time: {
			start: '10:00 AM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Desert Festival']
	},
	{
		name: 'Desert Festival',
		date: {
			season: 1,
			day: 16
		},
		location: 'Desert',
		time: {
			start: '10:00 AM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Desert Festival']
	},
	{
		name: 'Desert Festival',
		date: {
			season: 1,
			day: 17
		},
		location: 'Desert',
		time: {
			start: '10:00 AM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Desert Festival']
	},
	{
		name: 'Flower Dance',
		date: {
			season: 1,
			day: 24
		},
		location: 'Forest',
		time: {
			start: '9:00 AM',
			end: '2:00 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Flower Dance']
	},
	{
		name: 'Luau',
		date: {
			season: 2,
			day: 11
		},
		location: 'Beach',
		time: {
			start: '9:00 AM',
			end: '2:00 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes.Luau
	},
	{
		name: 'Trout Derby',
		date: {
			season: 2,
			day: 20
		},
		location: 'Cindersap Forest',
		time: {
			start: '6:10 AM',
			end: '2:00 AM'
		},
		icon: 'Hook.png',
		notes: EventNotes['Trout Derby']
	},
	{
		name: 'Trout Derby',
		date: {
			season: 2,
			day: 20
		},
		location: 'Cindersap Forest',
		time: {
			start: '6:10 AM',
			end: '2:00 AM'
		},
		icon: 'Hook.png',
		notes: EventNotes['Trout Derby']
	},
	{
		name: 'Dance of the Moonlight Jellies',
		date: {
			season: 2,
			day: 28
		},
		location: 'Beach',
		time: {
			start: '10:00 PM',
			end: '12:00 AM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Dance of the Moonlight Jellies']
	},
	{
		name: 'Stardew Valley Fair',
		date: {
			season: 3,
			day: 16
		},
		location: 'Pelican Town',
		time: {
			start: '9:00 AM',
			end: '3:00 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Stardew Valley Fair']
	},
	{
		name: 'Spirit\'s Eve',
		date: {
			season: 3,
			day: 27
		},
		location: 'Pelican Town',
		time: {
			start: '10:00 PM',
			end: '11:50 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Spirit\'s Eve']
	},
	{
		name: 'Festival of Ice',
		date: {
			season: 4,
			day: 8
		},
		location: 'Cindersap Forest',
		time: {
			start: '9:00 AM',
			end: '2:00 PM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Festival of Ice']
	},
	{
		name: 'SquidFest',
		date: {
			season: 4,
			day: 12
		},
		location: 'Beach',
		time: {
			start: '6:10 AM',
			end: '2:00 AM'
		},
		icon: 'Hook.png',
		notes: EventNotes.SquidFest
	},
	{
		name: 'SquidFest',
		date: {
			season: 4,
			day: 13
		},
		location: 'Beach',
		time: {
			start: '6:10 AM',
			end: '2:00 AM'
		},
		icon: 'Hook.png',
		notes: EventNotes.SquidFest
	},
	{
		name: 'Night Market',
		date: {
			season: 4,
			day: 15
		},
		location: 'Beach',
		time: {
			start: '5:00 PM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Night Market']
	},
	{
		name: 'Night Market',
		date: {
			season: 4,
			day: 16
		},
		location: 'Beach',
		time: {
			start: '5:00 PM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Night Market']
	},
	{
		name: 'Night Market',
		date: {
			season: 4,
			day: 17
		},
		location: 'Beach',
		time: {
			start: '5:00 PM',
			end: '2:00 AM'
		},
		icon: 'Star.png',
		notes: EventNotes['Night Market']
	},
	{
		name: 'Feast of the Winter Star',
		date: {
			season: 4,
			day: 25
		},
		location: 'Beach',
		time: {
			start: '9:00 AM',
			end: '2:00 AM'
		},
		icon: 'Flag.png',
		notes: EventNotes['Feast of the Winter Star']
	}
]

export default events